import React from 'react'

const MenuItem = ({submenu, path, currentPath, title, isSub, onClick, preventDefault}) => {

    let hasSub = (
        typeof submenu !== 'undefined' &&
        submenu.length
    )?true:false

    let allPossible = [path]

    if(hasSub && submenu) {
        allPossible = allPossible.concat(submenu.map(i => i.path))
    }

    return (
        <li 
            className={`${allPossible.includes(currentPath)?(isSub?'current-menu-ancestor':'current-menu-item'):''}`} 
        >
            <a 
                href={path}
                title={title} 
                aria-label={title}
                onClick={(e) => {
                    if(onClick) { 
                        if(preventDefault) {   
                            e.preventDefault()
                        }
                        onClick()
                    }
                }}
            >
                <span>{title}</span>
            </a>
            {hasSub?(
                <ul className="sub-menu">
                    {submenu && submenu.map((m,i) => (
                        <MenuItem {...m} currentPath={currentPath} isSub={true} key={i} onClick={onClick} preventDefault={preventDefault}/>
                    ))}
                </ul>
            ):null}
        </li>
    )
}

export default MenuItem


// WEBPACK FOOTER //
// ./src/app/components/MenuItem.js